module.exports = __webpack_public_path__ + "static/img/DanielRicciardo.579b918.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DanielRicciardo.jpg
// module id = 3fPD
// module chunks = 0